import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './lib/loadTracker' // must install the fetch/media patch before anything fetches
import './index.css'
import App from './App.tsx'
import LoadingScreen from './components/LoadingScreen.tsx'
import ChunkErrorBoundary from './components/ChunkErrorBoundary.tsx'
import { reloadForStaleChunk } from './lib/chunkReload'

// Vite's own signal for a stale-chunk <link rel="modulepreload"> failure —
// see lib/chunkReload.ts. This covers preload-tag failures; ChunkErrorBoundary
// below covers the same staleness surfacing as a React render-time throw.
window.addEventListener('vite:preloadError', () => {
  reloadForStaleChunk()
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <LoadingScreen />
      <ChunkErrorBoundary>
        <App />
      </ChunkErrorBoundary>
    </HelmetProvider>
  </StrictMode>,
)
